export const last = <ITEM>(array: ITEM[]): ITEM => array[array.length - 1];
export const head = <ITEM>(array: ITEM[]): ITEM => array[0];

const binarySearch =
  <ITEM>(compare: (a: ITEM, b: ITEM) => boolean) =>
  (
    array: [ITEM, ITEM][],
    value: ITEM,
    accessor: (item: [ITEM, ITEM]) => ITEM
  ) => {
    let lo = 0;
    let hi = array.length - 1;
    while (lo <= hi) {
      const mid = Math.floor((lo + hi) / 2);
      const element = array[mid];
      const each = accessor(element);
      if (each === value) {
        return mid;
      }
      if (compare(each, value)) {
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }
    return lo;
  };

export const binarySearchAscending = binarySearch(
  (a: number, b: number) => a < b
);
export const binarySearchDescending = binarySearch(
  (a: number, b: number) => a > b
);

function cumulativeSum(
  array: [number, number][],
  yAccessor: (val: number[]) => number,
  xAccessor: (val: number[]) => number
) {
  const cumulativeArray = array.reduce(
    (list, a) => {
      const value = xAccessor(a);
      const key = yAccessor(a);
      if (list.length > 0) {
        const { y } = last(list);
        const o = {
          x: key,
          y: y + value,
        };
        list.push(o);
      } else {
        const o = {
          x: key,
          y: value,
        };
        list.push(o);
      }
      return list;
    },
    [] as { x: number; y: number }[]
  );
  return cumulativeArray;
}

export function getCumulativePoints(values: [number, number][]) {
  const pointsCumulative = cumulativeSum(
    values,
    d => d[0],
    d => d[1]
  );
  return pointsCumulative;
}
